import {
  PaletteMode,
  Paper,
  Grid,
  Typography,
  useTheme,
  Collapse,
  IconButton,
  Button,
  Box,
} from "@mui/material";
import { FunctionComponent, useEffect, useMemo, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { experienceInformation } from "../../information/information";
import "./ProjectShowCaseDetail.css";
import React from "react";
import { Internship, Project } from "../../interfaces/InformationInterface";
import ArrowButton from "../ArrowButton/ArrowButton";
import { nanoid } from "nanoid";
interface Props {
  information?: Internship | Project | null;
  onClose?: () => any;
  hide?: boolean;
}
const dateShowOption: Intl.DateTimeFormatOptions = {
  month: "short",
  year: "numeric",
};

const dateShowLocation = "en-US";
const ProjectShowCaseDetail: FunctionComponent<Props> = (props) => {
  const theme = useTheme();
  const { information, onClose, hide = false } = props;
  const [loading,setLoad] = React.useState(true);
  const [curIndex, setIndex] = useState(0);
  const [isOpen, setOpen] = useState(false);
  const changePicture = (type:'FOWARD'|"BACKWARD") =>{
    setLoad(true);
    setIndex((prev) => (type==='FOWARD')?prev + 1:prev-1)
  }
  useEffect(() => {
    setIndex(0);
    if(information) setOpen(true)
  }, [information]);
  const maxLength = information?.idImage?.length || 0;
  function closeForm(){
    setOpen(false);
    setTimeout(()=>{
      onClose?.();
    },500)
  }
  if (curIndex === -1 || hide) return <></>;
  return (
    <Box className={`ProjectShowCaseDetail ${isOpen ? "open" : "close"}`} onClick={closeForm}>
      <div className="alignItem">
        <Grid
          container
          className={`card_container`}
          sx={{ background: theme.palette.background.default }}
          onClick={(e) => e.stopPropagation()}
          spacing={1}
        >
          <Grid
            item
            xs={12}
            sm={6}
            alignSelf={"center"}
            sx={{ maxHeight: "100%" }}
          >
            <Grid
              container
              justifyContent={"center"}
              alignItems={"center"}
              className="imageContainter"
            >
              {curIndex != 0 && (
                <ArrowButton
                  onClick={() => changePicture('BACKWARD')}
                  className="leftArrow"
                />
              )}
              {information?.idImage?.length !== 0 && (
                <Grid
                  item
                  onClick={() => window.open(`https://drive.google.com/file/d/${information?.idImage?.[curIndex]}/view?usp=sharing`)}
                >
                  <h3 style={{display:loading?'block':'none'}}>Loading</h3>
                  <img
                    crossOrigin="anonymous"
                    src={`https://www.googleapis.com/drive/v3/files/${information?.idImage?.[curIndex]}?alt=media&key=${process.env.REACT_APP_GOOGLE_API_KEY}`}
                    alt="information img"
                    className="informationImg"
                    style={{display:loading?'none':'block'}}
                    onLoad={()=>setLoad(false)}
                  />

                </Grid>
              )}
              {information?.idImage?.length == 0 && (
                <Grid item>
                  <Typography variant="h5">No image here</Typography>
                </Grid>
              )}
              {maxLength != 0 && curIndex != maxLength - 1 && (
                <ArrowButton
                  onClick={()=> changePicture('FOWARD')}
                  className="rightArrow"
                />
              )}
            </Grid>
          </Grid>
          <Grid item className="detailFormContainter" xs={12} sm={6}>
            <DetailForm information={information} />
          </Grid>
        </Grid>
      </div>
    </Box>
  );
};

const isInternship = (information: Internship): information is Internship =>
  !!information?.position;

interface DetailFormProps {
  information?: Internship | Project | null;
}
const DetailForm: FunctionComponent<DetailFormProps> = (props) => {
  let information: any = props.information;
  const theme = useTheme();
  const isIntern = isInternship(information);
  const startDate = React.useMemo(() => new Date(information?.startDate), []);
  const endDate = React.useMemo(
    () => (information?.endDate ? new Date(information?.endDate) : null),
    []
  );
  const writeDescription = () => {
    if (!isIntern) return information?.description;
    else {
      return (
        <ul style={{ marginTop: "0px" }}>
          {information?.description.map((val: string) => {
            return <li key={nanoid()}>{val}</li>;
          })}
        </ul>
      );
    }
  };
  return (
    <Box className="detailForm">
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography className="titleForm">{information?.title}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography>
            <div>
              <b>Date:</b>
            </div>
            {startDate.toLocaleString(dateShowLocation, dateShowOption)} -{" "}
            {endDate
              ? endDate.toLocaleString(dateShowLocation, dateShowOption)
              : "present"}
          </Typography>
        </Grid>
        {isIntern && (
          <Grid item xs={12} sm={6} style={{ marginLeft: "auto" }}>
            <div>
              <b>Position:</b>
            </div>{" "}
            {information?.position}
          </Grid>
        )}
        <Grid item xs={12}>
          <div>
            <b>Description:</b>
          </div>
          {writeDescription()}
        </Grid>
        {information?.url && isIntern && (
          <Grid item>
            <div
              className="linkShowMore"
              onClick={(e) => {
                e.stopPropagation();
                window.open(information?.url);
              }}
              style={{
                color: theme.palette.mode === "dark" ? "lightskyblue" : "blue",
              }}
            >
              View website
            </div>
          </Grid>
        )}
        {information?.url && !isIntern && (
          <Grid item>
            <div
              className="linkShowMore"
              onClick={(e) => {
                e.stopPropagation();
                window.open(information?.url);
              }}
              style={{
                color: theme.palette.mode === "dark" ? "lightskyblue" : "blue",
              }}
            >
              View project
            </div>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
export default ProjectShowCaseDetail;
